module.exports = __webpack_public_path__ + "img/step3-02.3e03aaee.jpg";